import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalComponent } from '../modal/modal.component';
import { CommonService } from 'src/app/common.service';
import { PaymentInfo, PaymentMethod, PaymentIntent as ProfilePaymentIntent } from 'profile-api';
import { ConfigurationVariablesList } from 'std-api';
import { GetCreditCardName } from '../utils/credit-card-name-getter'
import { Participation } from 'participation-api';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { StripeService } from 'ngx-stripe';
import { PaymentIntent } from '@stripe/stripe-js';

@Component({
    selector: 'app-buy-upgrade',
    templateUrl: './buy-upgrade.component.html',
    styleUrls: ['./buy-upgrade.component.css']
  })
  export class BuyUpgradeComponent implements OnInit {

    @ViewChild('errorModal') errorModal: ModalComponent;

    upgradePurchasePrice: number;
    paymentMethod: PaymentMethod = {};
    creditCardName: string;
    loading: boolean = false;
    tenderId: number;
    tenderTitle: string;
    tenderDescription: string;
    errorLoadingTender: string;
    error: string = "no_error";
    participation: Participation;

    privacyForm = new FormGroup({
        conditions: new FormControl('', [Validators.required]),
        privacy: new FormControl('', [Validators.required])
    });

    constructor(
        private commonService: CommonService,
        private route: ActivatedRoute,
        private router: Router,
        private stripeService: StripeService
    ) { }

    ngOnInit(): void {
        this.tenderTitle = localStorage.getItem('TENDER_TITLE');
        this.tenderDescription = localStorage.getItem('TENDER_DESCRIPTION');
        this.route.queryParams.subscribe(params => {
            this.tenderId = params['tenderId'];
        });

        this.getUpgradePurchasePrice();
        this.getPaymentMethod();
    }

    ngAfterViewInit(): void {
        if (this.errorLoadingTender) {
            this.errorModal.open();
        }
    }

    getUpgradePurchasePrice() {
        this.commonService.getConfigurationVariables().then(
            (variables: ConfigurationVariablesList) => {
                console.log('TENDER_PURCHASE_PRICE: ' + variables['TENDER_PURCHASE_PRICE']);
                let tenderPurchasePrice: number = variables['TENDER_PURCHASE_PRICE'];

                console.log('PRIVATE_TENDER_PURCHASE_PRICE: ' + variables['PRIVATE_TENDER_PURCHASE_PRICE']);
                let privateTenderPurchasePrice: number = variables['PRIVATE_TENDER_PURCHASE_PRICE'];

                this.upgradePurchasePrice = tenderPurchasePrice - privateTenderPurchasePrice;
            }
        );
    }

    getPaymentMethod() {
        this.loading = true;
        this.commonService.getPaymentMethodService().profilePaymentMethodGet().subscribe(
            (paymentMethod: PaymentMethod) => {
                this.loading = false;
                this.paymentMethod = paymentMethod;
                this.creditCardName = GetCreditCardName(paymentMethod.creditCardBrand);
            },
            (error) => {
                this.loading = false;
                this.error = "Si è verificato un errore durante il caricamento della carta di credito.";
                console.log(error);
            }
        )
    }

    buyUpgrade() {
        this.resetError();
        if (!this.privacyForm.valid || this.privacyForm.get('privacy').value === false || this.privacyForm.get('conditions').value === false) {
            this.error = "Per poter procedere è necessario prendere visione delle condizioni generali e della privacy.";
            console.log("Invalid privacy form");
            return;
        }

        this.loading = true;

        localStorage.removeItem('TENDER_TITLE');
        localStorage.removeItem('TENDER_DESCRIPTION');

        let description: string = 'UpgradeTenderID=' + this.tenderId;

        const transactionInfo = { amount: this.upgradePurchasePrice, description: description } as PaymentInfo;

        this.commonService.getPaymentMethodService().profileStripePaymentIntentPost(transactionInfo).subscribe(
            (paymentIntent: ProfilePaymentIntent) => {
                //Payment succesfully directly on server. Save the upgrade
                 this.commonService.getWorkflowService().tenderTenderIdUpgradePut(this.tenderId).subscribe(
                    () => {
                        this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": 'tenderDetail', "tenderId": this.tenderId } });
                    },
                    (error) => {
                        this.loading = false;
                        this.goToErrorPage(error.error.text);
                    }
                );
            },
            (error) => {
                if (error.error.cardExceptionErrorCode === 'authentication_required') {
                    this.confirmCardPayment(error.error.clientSecret, error.error.paymentMethodId);
                } else {
                    this.loading = false;
                    this.goToErrorPage(error.error.cardExceptionError);
                }
            }
        );
    }

    confirmCardPayment(clientSecret: string, paymentMethodId: string) {
        this.stripeService.confirmCardPayment(clientSecret, {
            payment_method: paymentMethodId
        }).subscribe(
            (value: { paymentIntent: PaymentIntent, error: any }) => {
                if (value.paymentIntent) {
                    //Payment succesfully directly on server. Save the upgrade
                    this.commonService.getWorkflowService().tenderTenderIdUpgradePut(this.tenderId).subscribe(
                        () => {
                            this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": 'tenderDetail', "tenderId": this.tenderId } });
                        },
                        (error) => {
                            this.loading = false;
                            this.goToErrorPage(error.error.text);
                        }
                    );
                } else {
                    //Payment intent is null when customer close authentication window without proceede to authenticate
                    this.loading = false;
                }
            },
            (error) => {
                this.loading = false;
                this.goToErrorPage(error.error.cardExceptionError);
            }
        );
    }

    goToErrorPage(error: string) {
        localStorage.setItem('BUY_UPGRADE_ERROR', error);
        this.router.navigate(['/erroreacquistoupgrade']);
    }

    resetError() {
        this.error = 'no_error';
    }
}

